import { render, staticRenderFns } from "./AddDependentsModal.vue?vue&type=template&id=3edffa2a&scoped=true&v-if=widgetReady&"
import script from "./AddDependentsModal.vue?vue&type=script&lang=js&"
export * from "./AddDependentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentsModal.vue?vue&type=style&index=0&id=3edffa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edffa2a",
  null
  
)

component.options.__file = "AddDependentsModal.vue"
export default component.exports